<template>
  <div>
    <b-card-group
      columns
      class="mb-5 card-columns-4 column-gap-5"
      v-for="(group,index) in grouped_items"
      :key="index"
    >
      <b-card
        :title="person.firstname"
        :sub-title="person.lastname"
        v-for="(person, index) in group"
        :key="index"
      >
        <p class="card-text">
          <strong>{{ $t('patient_card.firstname') }}</strong>: {{ person.firstname }}
        </p>
        <p class="card-text">
          <strong>{{ $t('patient_card.address') }}</strong>: {{ person.address }}
        </p>

        <b-button variant="primary" v-on:click="onItemClick(person)">
          {{ $t('patient_card.enter_button') }}
        </b-button>
      </b-card>
    </b-card-group>
  </div>
</template>


<script>
export default {
  name: "natural-person-card-list",
  props: {
    items: Array,
  },
  data() {
    return {
      grouped_items: [],
    };
  },
  mounted: function() {
    this.$nextTick(function() {
      this.groupedItems();
    });
  },
  fallbackI18n: {
    messages: {
      und: {
        patient_card: {
          firstname: "First name",
          address: "Address",
          enter_button: "Select",
        },
      },
    },
  },
  methods: {
    onItemClick(item) {
      this.$emit("org:click", item);
    },
    groupedItems() {
      var grouped = [];
      var group_elements = 4;
      var _group = [];
      var _count = 0;
      this.items.forEach(function(ph) {
        _group.push(ph);
        _count++;
        if (_count == group_elements) {
          grouped.push(_group);
          _group = [];
          _count = 0;
        }
      });
      if (_group.length > 0) {
        grouped.push(_group);
      }
      this.grouped_items = grouped;
    },
  },
};
</script>


<style scoped>
.dialog-footer {
  display: flex;
  justify-content: space-between;
}

.form-submit .el-button {
  width: 100%;
}
</style>
